export default __webpack_public_path__ + "static/media/Lavamanos uso rudo.43b6e199.png";